module.exports = __webpack_public_path__ + "media/site/images/app-preview/mobile-screen@2x-d437101617e7850c5a387401b17fafb2.png";